import Image from "next/image";
import pic4 from "../../../assets/demo.png";
import {
  useMostLikePodcastQuery,
  useMostViewPodcastQuery,
  useRecommendationPodcastQuery,
} from "@/Redux/features/podcast/podcastApi";
import { useRouter } from "next/router";
import Loading from "../loading";
import { formatCount } from "@/utilies/CountPositiveComments";

const CarouselTwo = ({ recommendationPodcast }) => {
  const router = useRouter();

  // const { data: recommendationPodcast, isLoading, isFetching } = useRecommendationPodcastQuery();
  const recommendationPodcasts = recommendationPodcast?.recommendations?.slice(
    0,
    2
  );

  // console.log(recommendationPodcast);

  const {
    data: mostViewPodcast,
    isLoading: viewLoading,
    isFetching: viewFetching,
  } = useMostViewPodcastQuery();
  const MostViewPodcast = mostViewPodcast?.podcast?.slice(0, 2);

  const {
    data: mostLikedPodcast,
    isLoading: likeLoading,
    isFetching: likeFetching,
  } = useMostLikePodcastQuery();
  const MostLikedPodcast = mostLikedPodcast?.podcast?.slice(0, 2);

  return (
    <div className="carousel w-full  dark:text-white my-5">
      {viewFetching ||
        viewLoading ||
        likeFetching ||
        (likeLoading && <Loading />)}

      <div
        id="slide2_1"
        className="carousel-item relative w-full md:py-24 lg:py-34"
      >
        <div className="px-5 lg:px-20 md:grid md:grid-cols-3 mb-10">
          <div className="md:col-span-1 my-auto">
            <p className="text-xl md:text-3xl lg:text-5xl font-bold text-blue-600 ">
              Top Podcast Series.
            </p>
            <p className="lg:text-lg font-normal my-5">
              The best podcasts are here: listen, download and follow your best
              reators. Lorem ipsum dolor sitamet, onsectetur adipiscing elit.
              Maecenas elitelit, lobortis non imperdiet et, ornare porta
              massa.Aliquam iaculis{" "}
            </p>

            <button
              onClick={() => router.push("/podcast")}
              className="uppercase border rounded-3xl px-6 py-3 font-semibold border-black mb-5 md:mb-0"
            >
              All Series
            </button>
          </div>

          <div className="md:col-span-2 grid grid-cols-2 gap-2">
            {recommendationPodcasts &&
              recommendationPodcasts?.map((podcast, i) => (
                <div
                  onClick={() =>
                    router.push(`/view-podcast?id=${podcast?._id}`)
                  }
                  key={i}
                  className="cursor-pointer lg:w-[335px] border rounded-md border-blue-500 p-2 shadow-blue-200 shadow-md"
                >
                  <Image
                    width={400}
                    height={200}
                    className="w-full rounded h-[180px] md:h-[250px] lg:w-[335px] lg:h-[384px]"
                    src={`${
                      podcast?.picture?.path ? podcast?.picture?.path : "/"
                    }`}
                    alt="logo"
                  />

                  <p className="font-semibold md:text-2xl text-blue-600 my-5 pl-2 md:pl-5">
                    {podcast?.title}
                  </p>

                  <div className="flex gap-2 justify-around md:mb-5 text-[10px] md:text-sm lg:text-base">
                    <p className="uppercase font-semibold">
                      Followers:{" "}
                      {formatCount(
                        podcast?.totalFollowers ? podcast?.totalFollowers : 0
                      )}
                    </p>
                    <p className="uppercase font-semibold">
                      Episodes:{" "}
                      {podcast?.episodes?.length > 0
                        ? podcast?.episodes?.length
                        : 0}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="hidden lg:block absolute lg:flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a
            href="#slide2_3"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❮
          </a>
          <a
            href="#slide2_2"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❯
          </a>
        </div>

        <div className="absolute bottom-3 md:bottom-10 left-[42%] md:left-[48%] flex gap-2">
          <a
            href="#slide2_1"
            className="p-1 border-4 border-blue-600 rounded-full  bg-blue-600"
          ></a>
          <a
            href="#slide2_2"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
          <a
            href="#slide2_3"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
        </div>
      </div>

      <div
        id="slide2_2"
        className="carousel-item relative w-full md:py-24 lg:py-34"
      >
        <div className="px-5 lg:px-20 md:grid md:grid-cols-3 mb-10">
          <div className="md:col-span-1  my-auto">
            <p className="text-3xl lg:text-5xl font-bold text-blue-600 ">
              Top View Podcast Series.
            </p>
            <p className="lg:text-lg font-normal my-5">
              The best podcasts are here: listen, download and follow your best
              reators. Lorem ipsum dolor sitamet, onsectetur adipiscing elit.
              Maecenas elitelit, lobortis non imperdiet et, ornare porta
              massa.Aliquam iaculis{" "}
            </p>

            <button
              onClick={() => router.push("/podcast")}
              className="uppercase border rounded-3xl px-6 py-3 font-semibold border-black mb-5 md:mb-0"
            >
              All Series
            </button>
          </div>

          <div className="md:col-span-2 grid grid-cols-2 gap-2">
            {MostViewPodcast &&
              MostViewPodcast?.map((podcast, i) => (
                <div
                  onClick={() =>
                    router.push(`/view-podcast?id=${podcast?._id}`)
                  }
                  key={i}
                  className="cursor-pointer lg:w-[335px] border rounded-md border-blue-500 p-2 shadow-blue-200 shadow-md"
                >
                  <Image
                    width={400}
                    height={200}
                    className="w-full h-[180px] md:h-[250px] lg:w-[335px] lg:h-[384px]"
                    src={`${
                      podcast?.picture?.path ? podcast?.picture?.path : "/"
                    }`}
                    alt="logo"
                  />

                  <p className="font-semibold md:text-2xl text-blue-600 my-5 pl-2 md:pl-5">
                    {podcast?.title}
                  </p>

                  <div className="flex gap-2 justify-around md:mb-5 text-[10px] md:text-sm lg:text-base">
                    <p className="uppercase font-semibold">
                      Followers:{" "}
                      {formatCount(
                        podcast?.totalFollowers ? podcast?.totalFollowers : 0
                      )}
                    </p>
                    <p className="uppercase font-semibold">
                      Episodes:{" "}
                      {podcast?.episodes?.length > 0
                        ? podcast?.episodes?.length
                        : 0}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="hidden lg:block absolute lg:flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a
            href="#slide2_1"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❮
          </a>
          <a
            href="#slide2_3"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❯
          </a>
        </div>

        <div className="absolute bottom-3 md:bottom-10 left-[42%] md:left-[48%] flex gap-2">
          <a
            href="#slide2_1"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
          <a
            href="#slide2_2"
            className="p-1 border-4 border-blue-600 rounded-full bg-blue-600 "
          ></a>
          <a
            href="#slide2_3"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
        </div>
      </div>

      <div
        id="slide2_3"
        className="carousel-item relative w-full md:py-24 lg:py-34"
      >
        <div className="px-5 lg:px-20 md:grid md:grid-cols-3 mb-10">
          <div className="md:col-span-1  my-auto">
            <p className="text-3xl lg:text-5xl font-bold text-blue-600 ">
              Top Liked Podcast Series.
            </p>
            <p className="lg:text-lg font-normal my-5">
              The best podcasts are here: listen, download and follow your best
              reators. Lorem ipsum dolor sitamet, onsectetur adipiscing elit.
              Maecenas elitelit, lobortis non imperdiet et, ornare porta
              massa.Aliquam iaculis{" "}
            </p>

            <button
              onClick={() => router.push("/podcast")}
              className="uppercase border rounded-3xl px-6 py-3 font-semibold border-black mb-5 md:mb-0"
            >
              All Series
            </button>
          </div>

          <div className="md:col-span-2 grid grid-cols-2 gap-2">
            {MostLikedPodcast &&
              MostLikedPodcast?.map((podcast, i) => (
                <div
                  onClick={() =>
                    router.push(`/view-podcast?id=${podcast?._id}`)
                  }
                  key={i}
                  className="cursor-pointer lg:w-[335px] border rounded-md border-blue-500 p-2 shadow-blue-200 shadow-md"
                >
                  <Image
                    width={400}
                    height={200}
                    className="w-full h-[180px] md:h-[250px] lg:w-[335px] lg:h-[384px]"
                    src={`${
                      podcast?.picture?.path ? podcast?.picture?.path : "/"
                    } `}
                    alt="logo"
                  />

                  <p className="font-semibold md:text-2xl text-blue-600 my-5 pl-2 md:pl-5">
                    {podcast?.title}
                  </p>

                  <div className="flex gap-2 justify-around md:mb-5 text-[10px] md:text-sm lg:text-base">
                    <p className="uppercase font-semibold">
                      Followers:{" "}
                      {formatCount(
                        podcast?.totalFollowers ? podcast?.totalFollowers : 0
                      )}
                    </p>
                    <p className="uppercase font-semibold">
                      Episodes:{" "}
                      {podcast?.episodes?.length > 0
                        ? podcast?.episodes?.length
                        : 0}
                    </p>
                  </div>
                </div>
              ))}
          </div>
        </div>

        <div className="hidden lg:block absolute lg:flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
          <a
            href="#slide2_2"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❮
          </a>
          <a
            href="#slide2_1"
            className="text-white btn btn-circle bg-blue-500 hover:bg-blue-400"
          >
            ❯
          </a>
        </div>

        <div className="absolute bottom-3 md:bottom-10 left-[42%] md:left-[48%] flex gap-2">
          <a
            href="#slide2_1"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
          <a
            href="#slide2_2"
            className="p-1 border-4 border-blue-600 rounded-full  "
          ></a>
          <a
            href="#slide2_3"
            className="p-1 border-4 border-blue-600 rounded-full bg-blue-600 "
          ></a>
        </div>
      </div>
    </div>
  );
};

export default CarouselTwo;
